<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Análisis de encuesta: </h4>
              <h4 class="pull">{{this.enunciado}}</h4>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <v-layout>
                <v-flex md6 lg6 xs6 sm6>
                  <label class="left" for="sel1">Ámbito</label>
                  <select class="form-control" id="5" @change="cambiaAmbito()" v-model="ambito">
                    <option selected disabled>-Selecciona una opción-</option>
                    <option value="0">Difusión</option>
                    <option value="1">Identificación</option>
                    <option value="2">Promoción de valores</option>
                    <option value="3">Referente Equidad</option>
                    <option value="4">Relevancia nacional</option>
                    <option value="5">Excelencia de pregrado</option>
                    <option value="6">Excelencia de postgrado</option>
                    <option value="7">Empleadores</option>
                  </select>
                </v-flex>
                <v-btn
                  small
                  color="#EB7704"
                  class="button topbut"
                  @click="downloadFile(9)"
                >Resultados Encuestas</v-btn>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
                    <br>

    <v-layout class="margin-footer" row v-if="ambito!=7">
      <v-flex md10 lg10 xs12 sm11>
  

        <carousel :per-page="2" :mouse-drag="true" :navigationNextLabel="'algo'" :speed="1500">
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <span class="title font-weight-light">Académicos</span>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <span class="title font-weight-light">Profesores por hora</span>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv2"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <span class="title font-weight-light">Funcionario</span>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv3"></v-flex>
            </v-card>
          </slide>
          <slide v-if="ambito != '6'">
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <span class="title font-weight-light">Estudiante Pregrado</span>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv4"></v-flex>
            </v-card>
          </slide>
          <slide v-if="ambito != '6'">
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <span class="title font-weight-light">Estudiante Postgrado</span>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv5"></v-flex>
            </v-card>
          </slide>
        </carousel>
      </v-flex>
    </v-layout>

    <v-layout class="margin-footer" v-if="ambito == 7" row>
      <v-flex md10 lg10 xs12 sm11>
        <carousel :per-page="2" :mouse-drag="true" :navigationNextLabel="'algo'" :speed="1500">
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <p class="title font-weight-light">Destaca por su pretigio nacional</p>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <p class="title font-weight-light">Se entrega un formación profesional de excelencia</p>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv2"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <p class="title font-weight-light">Tiene un cuerpo académico de alta calidad</p>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv3"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <p
                  class="title font-weight-light"
                >Se destaca por su compromiso con una educación pública de calidad</p>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv4"></v-flex>
            </v-card>
          </slide>
          <slide>
            <v-card class="mx-auto" color="#394049" dark>
              <v-card-title>
                <p
                  class="title font-weight-light"
                >Tiene una posición de influencia es discusiones relevantes en el medio nacional</p>
              </v-card-title>
              <v-flex xs12 md12 lg12 sm12 id="chartdiv5"></v-flex>
            </v-card>
          </slide>
        </carousel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import encuesta from "../util/encuesta.json";

am4core.useTheme(am4themes_animated);
export default {
  data() {
    return {
      enunciado: "",
      filesDge: "",
      cotaSuperior: "",
      menor: "",
      carreras: "",
      ambito: 0,
      listMenores: "",
      datachartfacultad: "",
      datachart: "encuesta",
      nombreAmbito: encuesta[0].nombre,
      first: true,
      create: false,
      edit: false,
      index: "",
      dialog: false,
      objetivoSelected: 1,
      objetivo: {
        nombre: "",
        propuestaObjetivo: ""
      },

      misionPropuesta:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word, Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word",

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    ambito: function() {
      //console.log("cambia datachart 6");
      this.chart("chartdiv", this.datachart[0]);
      this.chart("chartdiv2", this.datachart[1]);
      this.chart("chartdiv3", this.datachart[2]);
    }
  },

  mounted() {
    this.chart("chartdiv", this.datachart[0]);
    this.chart("chartdiv2", this.datachart[1]);
    this.chart("chartdiv3", this.datachart[2]);
    this.chart("chartdiv4", this.datachart[3]);
    this.chart("chartdiv5", this.datachart[4]);
  },

  created() {
    //console.log("dataaaaaaaaaaaaaaaaaaa");
    this.datachart = encuesta[0].valores;
    this.nombreAmbito = encuesta[0].name;
    this.enunciado = encuesta[0].description;
    //console.log(this.datachart);
    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDge = response.data;
        //console.log(this.filesDge);
        //console.log(this.filesDge["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });
  },

  updated: function() {
    this.$nextTick(function() {
      //console.log("cambia datachartv3");
      if (this.ambito == 6) {
        this.chart("chartdiv", this.datachart[0]);
        this.chart("chartdiv2", this.datachart[1]);
        this.chart("chartdiv3", this.datachart[2]);
      } else {
        this.chart("chartdiv", this.datachart[0]);
        this.chart("chartdiv4", this.datachart[3]);
        this.chart("chartdiv5", this.datachart[4]);
        this.chart("chartdiv2", this.datachart[1]);
        this.chart("chartdiv3", this.datachart[2]);
      }
    });
  },

  methods: {
    chart(nameChart, data) {
      var chart = am4core.create(nameChart, am4charts.PieChart);

      // Let's cut a hole in our Pie chart the size of 40% the radius
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

      chart.data = data;
      chart.radius = am4core.percent(70);
      chart.innerRadius = am4core.percent(40);
      chart.startAngle = 180;
      chart.endAngle = 360;

      var series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = "value";
      series.dataFields.category = "categoria";
      series.slices.template.tooltipText =
        "[bold {color}]{category}: {value.percent.formatNumber('#.0')}%[/]";
      series.slices.template.cornerRadius = 10;
      series.slices.template.innerCornerRadius = 7;
      series.slices.template.draggable = false;
      series.slices.template.inert = true;

      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;

      series.hiddenState.properties.startAngle = 90;
      series.hiddenState.properties.endAngle = 90;
      chart.legend = new am4charts.Legend();
      series.legendSettings.labelText = "[bold {color}]{name}[/]";
      series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";

      series.colors.list = [
        am4core.color("#de7c00"),
        am4core.color("#7c2529"),
        am4core.color("white"),
        am4core.color("#FFC75F"),
        am4core.color("#b1b1b1"),
        am4core.color("#F9F871")
      ];
    },

    redirect(index) {
      this.typeEstrategico = index;
    },

    cargaArchivos() {
      //console.log("Cambiando de departamento " + this.menor.ccValor);
      this.ambito = "";
      this.getDataChart(this.menor.ccValor);
    },

    cambiaAmbito() {
      this.datachart = encuesta[this.ambito].valores;
      this.nombreAmbito = encuesta[this.ambito].name;
      this.enunciado = encuesta[this.ambito].description;
    },

    sacaMaximo(arreglo) {
      var valores = [];
      arreglo.map(function(x) {
        valores.push(x.valor);
      });
      var max = Math.max.apply(null, valores);
      return max + 3;
    },

    agregaFacultad() {
      //console.log("agregando los valores de facultad");
      //console.log(this.datachartfacultad);
      var newdata = this.datachart;
      var i = 0;
      while (i < 4) {
        newdata[i]["valor2"] = this.datachartfacultad[i].valor;
        if (this.ambito != "") {
          newdata[i]["valor3"] = this.ambito.tasaTitulacion[i].valor;
        }
        i++;
      }
      //console.log("finally");
      //console.log(newdata);
      this.datachart = newdata;
    },

    getDataChart(cc) {
      axios
        .get(process.env.ROOT_API + "/indicador/getByCc?cc=" + cc, this.auth)
        .then(response => {
          this.datachart = response.data.tasaTitulacion;
          this.carreras = response.data.carreras;
          //console.log(this.carreras);
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => this.agregaFacultad())
        .then(response => {
          this.chart("chartdiv", this.datachart[0]);
          this.chart("chartdiv2", this.datachart[1]);
          this.chart("chartdiv3", this.datachart[2]);

          this.chart("chartdiv4", this.datachart[3]);
          this.chart("chartdiv5", this.datachart[4]);
        });
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateOtros(propuesta) {
      this.dialog = false;
    },

    openEditObservaciones() {
      this.create = false;
      this.edit = true;
    },

    opencreateObjetivo() {
      this.create = true;
      this.edit = true;
      this.objetivo = {
        nombre: "",
        propuestaObjetivo: ""
      };
    },

    editObservacion(objetivo) {
      //console.log(objetivo);
      this.objetivos[objetivo] = objetivo;
      this.edit = false;
    },

    createObjetivo() {
      //console.log(this.objetivo.queHaremos);
      this.objetivos.push(this.objetivo);
      this.edit = false;
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    }
  }
};
</script>


<style scoped>
#chartdiv2 {
  width: 100% !important;
  height: 300px !important;
}

.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 50px !important;
}

.v-card-new {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #fafafa;
  height: 400px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#chartdiv {
  width: 100%;
  height: 300px;
}

#chartdiv2 {
  width: 100%;
  height: 300px;
}

#chartdiv3 {
  width: 100%;
  height: 300px;
}

#chartdiv4 {
  width: 100%;
  height: 300px;
}

#chartdiv5 {
  width: 100%;
  height: 300px;
}

.mx-auto {
  border-radius: 10% !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  height: 380px !important;
}

.margin-footer {
  margin-bottom: 50px;
}
</style>

<style>
.VueCarousel-dot {
  background-color: #ec6a12 !important;
  outline: none !important;
}
.VueCarousel-dot--active {
  background-color: #273039 !important;
  outline: "none" !important;
}
.topbut {
  margin-top: 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/AnalisisEncuesta.vue